import { render } from "./BaseCardCarousel.vue?vue&type=template&id=40b783ec"
import script from "./BaseCardCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCardCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseCardCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40b783ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40b783ec', __exports__)) {
    console.log('reload')
    api.reload('40b783ec', __exports__)
  }
  
  module.hot.accept("./BaseCardCarousel.vue?vue&type=template&id=40b783ec", () => {
    console.log('re-render')
    api.rerender('40b783ec', render)
  })

}


export default __exports__